var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMenu = function SvgMenu(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.615 10.667a.615.615 0 1 0 0 1.23h14.77a.615.615 0 0 0 0-1.23zm0 4.922a.615.615 0 1 0 0 1.231h14.77a.615.615 0 0 0 0-1.23zm0 4.923a.615.615 0 1 0 0 1.231h14.77a.615.615 0 1 0 0-1.23z"
  })));
};
export default SvgMenu;